import CustomForm from "@components/global/CustomForm";
import { Option } from "@components/global/CustomSelect/CustomSelect";
import { GetAdminMinersList, GetUserMinersList } from "@services/getMinerList";
import { MinerRecordsResponse, RecordResponse, RecordsResponse } from "@services/http/responses/BaseResponse";
import useApiRequests from "@services/http/useApiRequest";
import { dev } from "@utils/dev";
import { useAuth } from "@utils/hooks/useAuth";
import { useEffect, useState } from "react";
import { CreateSparePart, ISparePartResponse, ISparePartType, UploadSparePartImage } from "../../SpareParts.http";
import { typesToOptions } from "../../SpareParts.utils";
import { IAdminMinerTable, IAdminMinerTableOrig } from "@services/getMinerInfo";

export type AddSparePartOnSuccess = (value: ISparePartResponse) => void;

const PAGE_SIZE = 10;

function useAddSparePartsModalControl(
  sparePartTypes: ISparePartType[],
  onSuccess: AddSparePartOnSuccess,
  handleClose: () => void,
) {

  const auth = useAuth();
  const [isLoading, setLoading] = useState(false);
  const requests = useApiRequests();
  const [search, setSearch] = useState<string[]>([]);
  const [miners, setMiners] = useState<IAdminMinerTable[]>([]);
  const [selectedMiner, setSelectedMiner] = useState<IAdminMinerTable | null>(null);
  const [selectedSparePartType, setSelectedSparePartType] = useState<ISparePartType | null>(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [options, setOptions] = useState<Option<number>[]>([]);

  useEffect(() => {
    setOptions(typesToOptions(sparePartTypes));
  }, []);

  async function submit(e: React.FormEvent<CustomForm>) {
    e.preventDefault();
    if (selectedSparePartType !== null) {
      const response = await requests.enqueue<RecordsResponse<ISparePartResponse | number>>(
        new CreateSparePart("new", selectedSparePartType.Id, selectedMiner?.id)
      );
      if (response && response.Status === "success") {
        if (response.Records.length > 0) {
          let result: ISparePartResponse;
          if (typeof response.Records[0] === "number") {
            result = {
              Id: response.Records[0],
              PartTypeId: selectedSparePartType.Id,
              MinerId: selectedMiner?.id ?? 0,
              Total: 0,
              Name: selectedSparePartType.Name, // SparePartType.Name "test 1717076319532",
              MinerStringId: selectedMiner?.miner_id ?? ""
            }
          } else {
            result = response.Records[0];
          }
          handleClose();
          onSuccess(result);
        }
      }
    }
  }

  async function findFirst(filter: string) {
    const splitted = filter.split(" ");
    setSearch(splitted);
    await getMinersList(splitted);
  }

  async function findNext(page: number) {
    await getMinersList(search, page, PAGE_SIZE);
  }

  async function pageChanged(page: number, pageSize: number) {
    setPage(page);
  }

  async function getMinersList(
    searchWords: string[],
    page: number = 1,
    pageSize: number = PAGE_SIZE,
  ): Promise<MinerRecordsResponse<IAdminMinerTableOrig> | void> {
    try {
      setLoading(true);
      const options = {
        offset: (page - 1) * pageSize,
        filter: {
          search: searchWords
        },
        limit: pageSize,
        // sort: storedSort[0],
        // dir: storedSort[1],
      };
      const query = auth.isAdmin ? GetAdminMinersList : GetUserMinersList;
      const response = await requests.enqueue<MinerRecordsResponse<IAdminMinerTable>>(
        new query(options.offset, options.limit, options.filter) //, options.sort, options.dir)
      );
      console.log("Found:", response);
      if (response) {
        // onGetMiners(response.Records, response.Total, {
        //   TotalActive: response.Totalactive || 0,
        //   TotalIncorrectId: response.Totalincorrectid || 0,
        //   TotalBroken: response.Totalbroken || 0,
        //   TotalUnknown: response.Totalunknown || 0,
        // });
        setPage(page);
        setTotal(response.Total);
        setMiners(response.Records);
      }
      return response;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    findNext(page);
  }, [page]);


  function draggerOnRemove(e: any) {
    dev.logt("Spareparts", "OnRemove", e);
  }
  async function draggerCustomRequest(e: any) {
    dev.logt("Spareparts", "CustomRequest", e);
    const file = e.file;
    const result = await requests.enqueueSilent<RecordResponse<string>>(
      new UploadSparePartImage(file)
    );

    dev.logt("Spareparts", "Upload result", result);
  }
  function draggerOnPreview(e: any) {
    dev.logt("Spareparts", "OnPreview", e);
  }

  const IMAGE_MAX_SIZE = 10 * 1024 * 1024 * 1024;
  const [images, setImages] = useState<any[]>([]);

  return {
    isLoading,
    miners,
    selectedMiner,
    pageSize: PAGE_SIZE,
    page,
    total,
    options,
    submit,
    findFirst,
    findNext,
    pageChanged,
    setSelectedMiner,
    setSelectedSparePartType,
    //////////
    draggerOnRemove,
    draggerCustomRequest,
    draggerOnPreview,
    images,
  }
}

export default useAddSparePartsModalControl; 